<template>
  <div class="special-main">
    <div class="wrap">
      <div class="special-main">
        <div class="special-header">
          <div class="special-header-left">
            <div class="special-title">{{ title }}</div>
          </div>
          <!-- <span class="more" @click="goAllSubject">更多</span> -->
        </div>
        <div class="special-content">
          <div
            class="recommend-empty"
            v-if="children.length === 0"
            v-loading="loading"
          >
            <img src="@/assets/imgs/bgi41.png" alt="" />
            <div class="recommend-empty-text">暂无数据</div>
          </div>
          <div class="special-list" v-else>
            <div
              class="special-item"
              @click="goDetail(item)"
              v-for="item in children"
              :key="item.id"
            >
              <div class="special-item-cover">
                <div class="special-item-cover-mark">{{ item.isRequired===1?'必修':'选修' }}</div>
                <img :src="item.image" alt="" />
              </div>
              <div class="special-item-title">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="item.storeName"
                  placement="top-start"
                >
                  <span>{{ item.cateName }}</span>
                </el-tooltip>
              </div>
            </div>
            <div
              class="special-item"
              v-for="item in [1, 2, 3]"
              :key="item"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "index",
  props: {
    title: {
      type: String,
      default: "",
    },
    children: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      active: 1,
      loading: false,
    };
  },
  methods: {
    handleClick(val) {
      this.active = val;
      if (val !== 1) {
        this.loading = true;
        const this_ = this;
        setTimeout(() => {
          this_.loading = false;
        }, 1500);
      } else {
        this.loading = false;
      }
    },
    goDetail(item) {
      let routeData = this.$router.resolve({
        name: "detail",
        query: { coursesId: item.id },
      });
      window.open(routeData.href, "_blank");
    },
    goSpecialDetail(item) {
      const { id, cateName, marks, pic } = item;
      let routeData = this.$router.resolve({
        name: "specialDetail",
        query: { id, cateName, marks, pic,title:this.title },
      });
      window.open(routeData.href, "_blank");
    },
    goAllSubject() {
      let routeData = this.$router.resolve({
        name: "allSubject",
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

<style scoped lang="scss">
.special-main {
  margin-top: 0px;

  .special-main {
    .special-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 20px;
      background-color: #fff;
      border-bottom: 1px solid #e9e9e9;

      .special-header-left {
        display: flex;
        align-items: center;

        .special-title {
          margin-right: 30px;
          font-size: 16px;
          font-weight: 700;
          color: #558ad6;
        }

        .special-cate {
          span {
            margin: 0 20px;
            font-size: 13px;
            color: #999;
            cursor: pointer;
          }

          .active {
            color: #558ad6;
          }
        }
      }

      .more {
        color: #558ad6;
        font-size: 14px;
        cursor: pointer;
      }
    }

    .special-content {
      min-height: 160px;
      background-color: #ffffff;
      padding: 8px 12px;

      .special-list {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;

        .special-item {
          width: 24.5%;
          padding: 12px;

          .special-item-cover {
            width: 100%;
            height: 150px;
            position: relative;
            overflow: hidden;
            border-radius: 6px;
            cursor: pointer;

            .special-item-cover-mark {
              position: absolute;
              top: 8px;
              left: 8px;
              padding: 2px 10px;
              font-size: 12px;
              color: #fff;
              background-color: rgba(0, 0, 0, 0.5);
              z-index: 10;
              border-radius: 4px;
            }

            img {
              width: 100%;
              height: 100%;
              transition: all 0.3s;
              vertical-align: middle;
            }
          }

          .special-item-cover:hover {
            img {
              transform: scale(1.1);
            }
          }

          .special-item-title {
            margin-top: 10px;
            font-size: 14px;
            color: #222;

            span {
              cursor: pointer;
              transition: all 0.3s;
            }
          }

          .special-item-title span:hover {
            color: #558ad6;
          }
        }
      }

      .recommend-empty {
        width: 100%;
        height: 100%;
        padding: 30px 10px;
        text-align: center;
        //line-height: 160px;

        img {
          height: 100px;
        }

        .recommend-empty-text {
          margin-top: 10px;
          color: #999;
          font-size: 13px;
        }
      }
    }
  }
}

@media (max-width: 600px) {
  .special-item {
    width: 49.5% !important;
    padding: 12px;
  }
  
}
</style>
